import css from "./shared-styles.css?inline"

const sheet = new CSSStyleSheet()
sheet.replaceSync(css)

export { sheet as sharedStyles }
